export default {"src":"/_next/static/media/ship-go.816f08fe.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};